/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: inherit;
  }
`

export default class ClubMessageIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="54.916" height="48.228" viewBox="0 0 54.916 48.228" css={Color}>
        <path
          id="패스_3261"
          data-name="패스 3261"
          d="M29.924,46.32H0V13.944H29.924l8.226-8.1L54.912,22.608l-7.363,7.524,7.367,7.031-16.9,16.911ZM18.641,30.132,38.01,49.164l12-12L30.642,18.131Zm7.814,12.72L16.188,32.585,5.922,42.851ZM3.469,40.4,13.735,30.132,3.469,19.865ZM45.1,27.679l4.915-5.066-12-12-4.915,5.067Zm-28.908,0L26.454,17.413H5.922Z"
          transform="translate(0 -5.846)"
          fill="#fff"
        />
      </svg>
    )
  }
}
